import { render, staticRenderFns } from "./LayoutConfig.vue?vue&type=template&id=aef6572a&scoped=true"
import script from "./LayoutConfig.vue?vue&type=script&lang=js"
export * from "./LayoutConfig.vue?vue&type=script&lang=js"
import style0 from "./LayoutConfig.vue?vue&type=style&index=0&id=aef6572a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef6572a",
  null
  
)

export default component.exports